import React, { useState, useEffect } from "react";
import "./RoofAreaInput.css";

export default function RoofAreaInput({ nextStep, updateFormData, propertyType }) {
  const [mode, setMode] = useState("manual"); // 'manual' or 'estimate'
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [canContinue, setCanContinue] = useState(false);
  const [roofArea, setRoofArea] = useState(null);

  // Roof area assumptions by property type
const estimatedAreasByType = {
  detached: 40,
  "semi detached": 25,
  terraced: 18.75,
  bungalow: 50,
};

const normalizeType = (str) =>
  str?.toLowerCase().replace(/[-_]/g, " ").trim();

const normalizedType = normalizeType(propertyType);
const estimatedArea = estimatedAreasByType[normalizedType] ?? 30;
  const panelEstimate = roofArea ? Math.floor(roofArea / 2.0) : null; //2.0sqm solar panels//

  useEffect(() => {
    if (mode === "estimate") {
      setRoofArea(estimatedArea);
      setCanContinue(true);
    } else {
      const w = parseFloat(width);
      const h = parseFloat(height);
      if (!isNaN(w) && !isNaN(h) && w > 0 && h > 0) {
        const calculated = w * h;
        setRoofArea(calculated);
        setCanContinue(true);
      } else {
        setRoofArea(null);
        setCanContinue(false);
      }
    }
  }, [mode, width, height, estimatedArea]);

  const handleContinue = () => {
    updateFormData({ roofArea, mode });
    nextStep();
  };

  return (
    <div className="roof-area-input-screen">
      <h2>Tell us about your roof</h2>
      <p>Use the toggle below to switch between manual entry of your roof area or let us estimate it based on the house type you selected on the previous screen.</p>

      <div className="roof-mode-toggle">
        <div
          className={`roof-card ${mode === "manual" ? "active" : "inactive"}`}
        >
          <h3>Enter dimensions</h3>
          <p>Estimate the dimensions of your sunniest roof elevation in meters.</p>
          <div className="manual-inputs">
            <input
              type="number"
              placeholder="Width (m)"
              value={width}
              onChange={(e) => setWidth(e.target.value)}
              disabled={mode !== "manual"}
            />
            <input
              type="number"
              placeholder="Height (m)"
              value={height}
              onChange={(e) => setHeight(e.target.value)}
              disabled={mode !== "manual"}
            />
          </div>
        </div>

        <div
          className={`roof-card ${mode === "estimate" ? "active" : "inactive"}`}
        >
          <h3>Let us estimate</h3>
          <p>We'll use a typical roof size for your property type selected in the previous step.</p>
          {mode === "estimate" && (
            <div className="estimate-preview">
              <strong>{propertyType}</strong>: {estimatedArea} m²
            </div>
          )}
        </div>
      </div>

      <div className="toggle-wrapper">
        <label className="switch-label">Mode:</label>
        <div className="switch-container">
          <span>Manual</span>
          <label className="switch">
            <input
              type="checkbox"
              checked={mode === "estimate"}
              onChange={() =>
                setMode((prev) => (prev === "manual" ? "estimate" : "manual"))
              }
            />
            <span className="slider round"></span>
          </label>
          <span>Estimate</span>
        </div>
      </div>

      {roofArea && (
        <p className="panel-estimate">
          This could fit approximately <strong>{panelEstimate}</strong> solar panels.
        </p>
      )}

      <button
        className="continue-button"
        onClick={handleContinue}
        disabled={!canContinue}
      >
        Continue
      </button>
    </div>
  );
}
